import { render, staticRenderFns } from "./CompSalesBarchart.vue?vue&type=template&id=180fd0fd"
import script from "./CompSalesBarchart.vue?vue&type=script&lang=js"
export * from "./CompSalesBarchart.vue?vue&type=script&lang=js"
import style0 from "./CompSalesBarchart.vue?vue&type=style&index=0&id=180fd0fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports